import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AdminLayout from '@/components/AdminLayout';
import { API } from '@/App';
import { Sparkles, Bug, Wrench, Calendar, Tag } from 'lucide-react';

const ReleaseNotesPage = () => {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');

  useEffect(() => {
    axios.get(`${API}/admin/deployment-info`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setInfo(r.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <AdminLayout><div className="p-8 text-gray-400">Chargement…</div></AdminLayout>;

  const notes = info?.release_notes || {};

  return (
    <AdminLayout>
      <div className="p-4 sm:p-6 lg:p-8 max-w-4xl" data-testid="release-notes-page">
        <div className="flex items-start justify-between mb-6 flex-wrap gap-3">
          <div>
            <h1 className="text-2xl font-bold text-[#1e3a5f]" style={{ fontFamily: "'Barlow', sans-serif" }}>
              Notes de version
            </h1>
            <p className="text-sm text-gray-500 mt-1">Historique des dernières mises à jour de l'application SFOALC</p>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#1e3a5f] text-white text-xs font-bold">
              <Tag size={12} /> v{info?.version || '1.0.0'}
            </span>
            {info?.deployed_at && (
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-gray-100 text-gray-600 text-xs font-medium">
                <Calendar size={12} /> {new Date(info.deployed_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
              </span>
            )}
          </div>
        </div>

        {notes.highlights && notes.highlights.length > 0 && (
          <section className="mb-6 bg-white rounded-2xl border border-gray-100 p-5 sm:p-6">
            <h2 className="text-sm font-bold text-[#1e3a5f] uppercase tracking-wider mb-4 flex items-center gap-2">
              <Sparkles size={14} className="text-[#35AFE4]" /> Nouveautés
            </h2>
            <ul className="space-y-3">
              {notes.highlights.map((h, i) => (
                <li key={i} className="flex gap-3 text-sm text-gray-700" data-testid={`highlight-${i}`}>
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#35AFE4]/10 text-[#35AFE4] text-[10px] font-bold flex items-center justify-center mt-0.5">{i + 1}</span>
                  <span>{h}</span>
                </li>
              ))}
            </ul>
          </section>
        )}

        {notes.improvements && notes.improvements.length > 0 && (
          <section className="mb-6 bg-white rounded-2xl border border-gray-100 p-5 sm:p-6">
            <h2 className="text-sm font-bold text-[#1e3a5f] uppercase tracking-wider mb-4 flex items-center gap-2">
              <Wrench size={14} className="text-emerald-500" /> Améliorations
            </h2>
            <ul className="space-y-2">
              {notes.improvements.map((h, i) => (
                <li key={i} className="flex gap-2 text-sm text-gray-700">
                  <span className="text-emerald-500">→</span><span>{h}</span>
                </li>
              ))}
            </ul>
          </section>
        )}

        {notes.fixes && notes.fixes.length > 0 && (
          <section className="mb-6 bg-white rounded-2xl border border-gray-100 p-5 sm:p-6">
            <h2 className="text-sm font-bold text-[#1e3a5f] uppercase tracking-wider mb-4 flex items-center gap-2">
              <Bug size={14} className="text-amber-500" /> Correctifs
            </h2>
            <ul className="space-y-2">
              {notes.fixes.map((h, i) => (
                <li key={i} className="flex gap-2 text-sm text-gray-600">
                  <span className="text-amber-500">✓</span><span>{h}</span>
                </li>
              ))}
            </ul>
          </section>
        )}

        {(!notes.highlights && !notes.fixes && !notes.improvements) && (
          <div className="bg-white rounded-2xl border border-gray-100 p-8 text-center text-gray-400 text-sm">
            Aucune note de version disponible.
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default ReleaseNotesPage;
